<script>
    export default {
        props: {
            officeExecutives: Number,
            totalUltraAdmins: Number,
            othersOfficeExecutives: Number
        },
        data() {
            return {
                
            };
        },
        computed: {
            // Example admin, sb, tc, tp
            userTypeAbbr() {
                return this.$page.props.auth.user.user_type_abbr;
            },
        },
        methods: {
            
        }
    };
</script>

<template>
    <div class="nav flex-column nav-pills for_check_active_nav" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        <a :href="route('admin-office-executives')" class="nav-link">
            <i class= "fas fa-users d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Own Teammates {{ officeExecutives }}</p>
        </a>
        <a :href="('/admin/contacts/office-executives#create')" class="nav-link">
            <i class= "fas fa-user-plus d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Create Teammate</p>
        </a>
        <Link :href="route('ultra-admin.index')" class="nav-link active">
            <i class= "fas fa-users d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Ultra Admins {{ totalUltraAdmins }}</p>
        </Link>
        <a :href="route('admin-others-office-executives')" class="nav-link">
            <i class= "fas fa-users d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">System's Teammates {{ othersOfficeExecutives }}</p>
        </a>
    </div>
</template>